import { render, staticRenderFns } from "./RootCategoryEdit.vue?vue&type=template&id=232addf6&scoped=true&"
import script from "./RootCategoryEdit.vue?vue&type=script&lang=js&"
export * from "./RootCategoryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232addf6",
  null
  
)

export default component.exports